import React, { Component, type JSX } from 'react';
import { SortType } from './SearchBooster';

interface SearchResultsSummaryProps {
  city: string;
  locationNotFound: boolean;
  numTrainings: number;
  numLocations: number; // number of tutor locations
  type: SortType;
}

export class SearchBoosterResultsSummary extends Component<SearchResultsSummaryProps> {

  public render(): JSX.Element {
    let { locationNotFound, numTrainings, numLocations, type, city } = this.props;

    if (locationNotFound && city) {
      return (<NotFound city={city}/>);
    }
    return (
      <Summary
        numTrainings={numTrainings}
        numLocations={numLocations}
        type={type}/>
    );
  }
}

// no trainings are found
export const NotFound = (props: { city: string }): JSX.Element => {
  return (
    <div className="front-search__summary">
      Plaats <strong>&quot;{props.city}&quot;</strong> niet gevonden
    </div>
  );
};

interface SummaryProps {
  numTrainings: number;
  numLocations: number; // number of tutor locations
  type: SortType;
}

// print the actual summary
export const Summary = (props: SummaryProps): JSX.Element => {
  return (
    <div className="front-search__summary">
      <strong>{props.numTrainings} trainingen </strong>
      <span className="front-search__summary-locations"
      >{(props.numLocations && props.type === 'distance')
          ? `beschikbaar (op ${props.numLocations} locaties)`
          : null
        }
      </span>
    </div>
  );
};
